import React from "react";

import FinancialHistoryPage from "./FinancialHistoryPage";

export default function InvestorHistoryPage() {
  return <FinancialHistoryPage isAdmin={false} />;
}
